import script from "./RemainingDays.vue?vue&type=script&setup=true&lang=js"
export * from "./RemainingDays.vue?vue&type=script&setup=true&lang=js"

import "./RemainingDays.vue?vue&type=style&index=0&id=4caac3ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4caac3ce"]])

export default __exports__